import { FilterDef } from "@/stores/filters/FilterDef";

export class EvaluationLevelFilterDef extends FilterDef {



}
